import React, { useState, useEffect, Component, useRef, forwardRef } from "react";
import styled from "styled-components";
import background from "../../assets/meso-game-bg.png";
import PracticeGame from "../../components/PracticeGameAssessment";
import useTopicQuestions from "../../hooks/useTopicQuestions";
import useSpeech from "../../hooks/useSpeech";
import { debug } from "util";
import { render } from "react-dom";
//import style from './Geo.module.css';
import { Textfit } from 'react-textfit';

import style from '../../components/Geo.module.css';
import { Scale } from 'react-scaling';
//modes
import AsCalculator from "../../components/AsCalculator";
import AsCalculatorFraction from "../../components/AsCalculatorFraction";
import AsCalculatorFractionMixed from "../../components/AsCalculatorFractionMixed";

import axios from "axios";
import useAuth from "../../../auth/hooks/useAuth";

import next from "../../assets/maths_assessments/assets/Next.png";
import back from "../../assets/maths_assessments/assets/Back.png";
import blankbg from "../../assets/maths_assessments/assets/Blank.png";
import marks1 from "../../assets/maths_assessments/assets/marks1.png";

//Holds the current question with elements:
//question: question text
//answers: (correct: bool, value: answer string),
//correct: string of correct answer
var currQuestion;
var image;
var timer = -1;

//THESE VARIABLES NEED TO BE OUTSIDE THE EXPORT OTHERWISE THEY ARE SET TO DEFAULT EVERY FRAME
var questionNum = 0;
var useranswers = [];
var shuffledAnswers = [];


//Mixes up array
function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
}


export default function SpringAr({ ...props }) {
  const [loading, setLoading] = useState(true);
  const [correctQuestions, setCorrectQuestions] = useState([]);
  const [incorrectQuestions, setIncorrectQuestions] = useState([]);
  const [score, setScore] = useState(0);
  const [combo, setCombo] = useState(0);
  const [maxCombo, setMaxCombo] = useState(0);
  const [feedback, setFeedback] = useState([]);
  const { state: authState } = useAuth();
  const [gameOver, setGameOver] = useState(false);

  const [clearCalc, setClear] = useState(false);

  //this.calculator = React.createRef();


  /*
  const { questions, status } = useTopicQuestions({
    topics: props.topics,
    game_type: props.gameType
  });*/
  const [currentQuestion, setCurrentQuestion] = useState([]);
  const [extraChars, setExtraChars] = useState([]);
  const [refresh, setRefresh] = useState(false)
  const [displayImage, setDisplayImage] = useState(false);

  const[showColouredFeedback, setColouredFeedback] = useState(false);
  const [waitTime, setWaitTime] = useState(2);

  const [status, setStatus] = useState(false);

  //0 = keypad, 
  //1 = multiple choice,
  // 2 = fraction,
  // 3 = int & frac
  //4 = multiple choice 2
  
  //questions section
  var questionsY1Progress1 = [];

  questionsY1Progress1.push({ "question" : "What is the smallest number shown on the number line?", "answer" : "0", "type": "NP", "units" : "", "marks" : 1})
questionsY1Progress1.push({ "question" : "What is the largest number shown on the number line?", "answer" : "10", "type": "NP", "units" : "", "marks" : 1})
questionsY1Progress1.push({ "question" : "What number is shown in the ten frame?", "answer" : "6", "type": "NP", "units" : "", "marks" : 1})
questionsY1Progress1.push({ "question" : "Emile is counting from 1-10. She says, “eight.” What number comes next?", "answer" : "Nine|Seven|Ten|Eight", "type": "MC", "units" : "", "marks" : 1})
questionsY1Progress1.push({ "question" : "What number comes before 5?", "answer" : "4", "type": "NP", "units" : "", "marks" : 1})
questionsY1Progress1.push({ "question" : "What number should replace A on the number line?", "answer" : "4|5|3|7", "type": "MC", "units" : "", "marks" : 1})
questionsY1Progress1.push({ "question" : "What number should replace B on the number line?", "answer" : "7|4|3|5", "type": "MC", "units" : "", "marks" : 1})
questionsY1Progress1.push({ "question" : "I walked 3km to Aimee's house, and then cycled another 2km with Aimee. How far have I traveled?", "answer" : "5", "type": "NP", "units" : "km", "marks" : 1})
questionsY1Progress1.push({ "question" : "Which number sentence matches the picture?", "answer" : "3 + 4 = 7|3 + 3 = 6|4 + 2 = 6|5 + 2 = 7", "type": "MC", "units" : "", "marks" : 1})
questionsY1Progress1.push({ "question" : "Complete the number sentence:", "answer" : "7", "type": "NP", "units" : "", "marks" : 1})
questionsY1Progress1.push({ "question" : "hat", "answer" : "8", "type": "NP", "units" : "", "marks" : 1})
questionsY1Progress1.push({ "question" : "Complete the number sentence:", "answer" : "9", "type": "NP", "units" : "", "marks" : 1})
questionsY1Progress1.push({ "question" : "Complete the number sentence:", "answer" : "10", "type": "NP", "units" : "", "marks" : 1})
questionsY1Progress1.push({ "question" : "Complete the number sentence:", "answer" : "5", "type": "NP", "units" : "", "marks" : 1})
questionsY1Progress1.push({ "question" : "Complete the number sentence:", "answer" : "4", "type": "NP", "units" : "", "marks" : 1})
questionsY1Progress1.push({ "question" : "Complete the number sentence:", "answer" : "3", "type": "NP", "units" : "", "marks" : 1})
questionsY1Progress1.push({ "question" : "Complete the number sentence:", "answer" : "2", "type": "NP", "units" : "", "marks" : 1})
questionsY1Progress1.push({ "question" : "There are 5 counters altogether. How many counters are hiding?", "answer" : "2", "type": "NP", "units" : "", "marks" : 1})
questionsY1Progress1.push({ "question" : "How many apples are there altogether?", "answer" : "8", "type": "NP", "units" : "", "marks" : 1})
questionsY1Progress1.push({ "question" : "What is the missing number?", "answer" : "5", "type": "NP", "units" : "", "marks" : 1})
questionsY1Progress1.push({ "question" : "What is the missing number?", "answer" : "4", "type": "NP", "units" : "", "marks" : 1})
questionsY1Progress1.push({ "question" : "What is the missing number?", "answer" : "3", "type": "NP", "units" : "", "marks" : 1})
questionsY1Progress1.push({ "question" : "What is the missing number?", "answer" : "2", "type": "NP", "units" : "", "marks" : 1})
questionsY1Progress1.push({ "question" : "What is the missing number?", "answer" : "1", "type": "NP", "units" : "", "marks" : 1})
questionsY1Progress1.push({ "question" : "What is the missing number?", "answer" : "0", "type": "NP", "units" : "", "marks" : 1})
  
var questionsY1Progress2 = [];


questionsY1Progress2.push({ "question" : "What is the value of A?", "answer" : "8", "type": "NP", "units" : "", "marks" : 1})
questionsY1Progress2.push({ "question" : "What is the value of B?", "answer" : "2", "type": "NP", "units" : "", "marks" : 1})
questionsY1Progress2.push({ "question" : "What is the value of C?", "answer" : "14", "type": "NP", "units" : "", "marks" : 1})
questionsY1Progress2.push({ "question" : "What is the value of D?", "answer" : "5", "type": "NP", "units" : "", "marks" : 1})
questionsY1Progress2.push({ "question" : "What is the value of E?", "answer" : "15", "type": "NP", "units" : "", "marks" : 1})
questionsY1Progress2.push({ "question" : "What is the value of F?", "answer" : "5", "type": "NP", "units" : "", "marks" : 1})
questionsY1Progress2.push({ "question" : "What is the value of G?", "answer" : "9", "type": "NP", "units" : "", "marks" : 1})
questionsY1Progress2.push({ "question" : "What number comes next?", "answer" : "fifteen|nineteen|five|fiveteen", "type": "MC", "units" : "", "marks" : 1})
questionsY1Progress2.push({ "question" : "What number is shown in the ten frame?", "answer" : "14", "type": "NP", "units" : "", "marks" : 1})
questionsY1Progress2.push({ "question" : "Which 2d shape is a triangle?", "answer" : "A|B|C", "type": "MC", "units" : "", "marks" : 1})
questionsY1Progress2.push({ "question" : "Which 3d shape is a cylinder?", "answer" : "E|D|F|G", "type": "MC", "units" : "", "marks" : 1})
questionsY1Progress2.push({ "question" : "Which 3d shape is a pyramid?", "answer" : "G|D|F|E", "type": "MC", "units" : "", "marks" : 1})


  
  


  var questionsY2Progress1 = [];
  questionsY2Progress1.push({ "question" : "Estimate how long line A is by comparing it to the 100 cm line.", "answer" : "50cm|10cm|100cm|80cm", "type": "MC", "units" : "", "marks" : 1})
  questionsY2Progress1.push({ "question" : "Estimate how long line B is by comparing it to the 100 cm line.", "answer" : "20cm|50cm|100cm|80cm", "type": "MC", "units" : "", "marks" : 1})
  questionsY2Progress1.push({ "question" : "Estimate how long line C is by comparing it to the 100 cm line.", "answer" : "80cm|50cm|100cm|20cm", "type": "MC", "units" : "", "marks" : 1})
  questionsY2Progress1.push({ "question" : "The table shows the colours of gems that Emile has found. Which colour has Emile found between 20 and 30 gems?", "answer" : "Blue|Red|Orange|Gold", "type": "MC", "units" : "", "marks" : 1})
  questionsY2Progress1.push({ "question" : "Emile thinks of a number. They say, “My number is between 30 and 40. It has 4 in the ones place.” What is Emile's number?", "answer" : "34", "type": "NP", "units" : "", "marks" : 1})
  questionsY2Progress1.push({ "question" : "What number should replace A on the number line?", "answer" : "45", "type": "NP", "units" : "", "marks" : 1})
  questionsY2Progress1.push({ "question" : "What number should replace B on the number line?", "answer" : "58", "type": "NP", "units" : "", "marks" : 1})
  questionsY2Progress1.push({ "question" : "Aimee has used 10m rods and 1m cubes to measure the length of the rocket. How long is the rocket in metres?", "answer" : "43", "type": "NP", "units" : "m", "marks" : 1})
  questionsY2Progress1.push({ "question" : "What is the missing number?", "answer" : "87", "type": "NP", "units" : "", "marks" : 1})
  questionsY2Progress1.push({ "question" : "What is the missing number?", "answer" : "60", "type": "NP", "units" : "", "marks" : 1})
  questionsY2Progress1.push({ "question" : "Emile collects 28 gems and gives 8 of them to Aimee. How many gems does Emile have left?", "answer" : "20", "type": "NP", "units" : "", "marks" : 1})
  questionsY2Progress1.push({ "question" : "Looking at the part whole model, what values are A and B?", "answer" : "A is 30, B is 4|A is 20, B is 40|A is 30, B is 40|A is 3, B is 4", "type": "MC", "units" : "", "marks" : 1})


  var questionsY2Progress2 = [];



questionsY2Progress2.push({ "question" : "What is the missing value?", "answer" : "12", "type": "NP", "units" : "", "marks" : 1})
questionsY2Progress2.push({ "question" : "What is the missing value?", "answer" : "11", "type": "NP", "units" : "", "marks" : 1})
questionsY2Progress2.push({ "question" : "What is the missing value?", "answer" : "14", "type": "NP", "units" : "", "marks" : 1})
questionsY2Progress2.push({ "question" : "What is the missing value?", "answer" : "7", "type": "NP", "units" : "", "marks" : 1})
questionsY2Progress2.push({ "question" : "What is the missing value?", "answer" : "6", "type": "NP", "units" : "", "marks" : 1})
questionsY2Progress2.push({ "question" : "What is the missing value?", "answer" : "5", "type": "NP", "units" : "", "marks" : 1})
questionsY2Progress2.push({ "question" : "Emile spends £9 on food and £5 on a drink. How much has Emile spent altogether?", "answer" : "14", "type": "NP", "units" : "£", "marks" : 1})
questionsY2Progress2.push({ "question" : "Emile has 14 apples. Aimee takes 7 apples. How many apples does Emile have left?", "answer" : "7", "type": "NP", "units" : "apples", "marks" : 1})
questionsY2Progress2.push({ "question" : "What is the missing value?", "answer" : "8", "type": "NP", "units" : "", "marks" : 1})
questionsY2Progress2.push({ "question" : "There are 7 red gems and 3 blue gems. What is the difference between the number of red gems and blue gems?", "answer" : "4", "type": "NP", "units" : "gems", "marks" : 1})
questionsY2Progress2.push({ "question" : "Emile has £17 and they want to buy a hat that costs £26. How much more money does Emile need to buy the hat?", "answer" : "9", "type": "NP", "units" : "£", "marks" : 1})
questionsY2Progress2.push({ "question" : "Emile takes 20 minutes to clean the rocket. So far he has been cleaning for 13 minutes. How much longer will Emile have to clean for?", "answer" : "7", "type": "NP", "units" : "minutes", "marks" : 1})
questionsY2Progress2.push({ "question" : "What is the missing value?", "answer" : "39", "type": "NP", "units" : "", "marks" : 1})
questionsY2Progress2.push({ "question" : "What is the value of A?", "answer" : "4", "type": "NP", "units" : "", "marks" : 1})
questionsY2Progress2.push({ "question" : "What is the value of B?", "answer" : "1", "type": "NP", "units" : "", "marks" : 1})
questionsY2Progress2.push({ "question" : "Emile has 17 red gems and 9 blue gems. How many gems does Emile have altogether?", "answer" : "26", "type": "NP", "units" : "gems", "marks" : 1})


  

  
  

  var questionsY3Progress1 = [];

  questionsY3Progress1.push({ "question" : "How many 10cm lengths can a 420cm length of ribbon be cut into?", "answer" : "42", "type": "NP", "units" : "", "marks" : 1})
questionsY3Progress1.push({ "question" : "Scrambler sells 43 flowers for 10p each. How much money does Scrambler take?", "answer" : "4.300000", "type": "NP", "units" : "£", "marks" : 1})
questionsY3Progress1.push({ "question" : "Emile  weighs 30kg. Aimee weighs 10 times as much as Emile. What is Aimee's weight?", "answer" : "300", "type": "NP", "units" : "kg", "marks" : 1})
questionsY3Progress1.push({ "question" : "Which numbers are all multiples of 10?", "answer" : "750, 890, 350, 210|750, 895, 350, 210|750, 890, 354, 210|750, 890, 350, 212", "type": "MC", "units" : "", "marks" : 1})
questionsY3Progress1.push({ "question" : "What number is represented by the counters?", "answer" : "537", "type": "NP", "units" : "", "marks" : 1})
questionsY3Progress1.push({ "question" : "What number is represented by this expression?", "answer" : "232", "type": "NP", "units" : "", "marks" : 1})
questionsY3Progress1.push({ "question" : "Looking at the part whole model, what value is A?", "answer" : "2", "type": "NP", "units" : "", "marks" : 1})
questionsY3Progress1.push({ "question" : "Looking at the part whole model, what value is B?", "answer" : "647", "type": "NP", "units" : "", "marks" : 1})
questionsY3Progress1.push({ "question" : "What is the missing number?", "answer" : "738", "type": "NP", "units" : "", "marks" : 1})
questionsY3Progress1.push({ "question" : "What is the missing number?", "answer" : "300", "type": "NP", "units" : "", "marks" : 1})
questionsY3Progress1.push({ "question" : "What is the missing number?", "answer" : "900", "type": "NP", "units" : "", "marks" : 1})
questionsY3Progress1.push({ "question" : "What is the value of A?", "answer" : "600", "type": "NP", "units" : "", "marks" : 1})
questionsY3Progress1.push({ "question" : "What is the value of B?", "answer" : "300", "type": "NP", "units" : "", "marks" : 1})
questionsY3Progress1.push({ "question" : "What is the value of C?", "answer" : "330", "type": "NP", "units" : "", "marks" : 1})
questionsY3Progress1.push({ "question" : "What is the value of D?", "answer" : "360", "type": "NP", "units" : "", "marks" : 1})
questionsY3Progress1.push({ "question" : "What is the value of E?", "answer" : "370", "type": "NP", "units" : "", "marks" : 1})
questionsY3Progress1.push({ "question" : "What number should replace F on the number line?", "answer" : "225|250|275|175", "type": "MC", "units" : "", "marks" : 1})
questionsY3Progress1.push({ "question" : "What number should replace G on the number line?", "answer" : "450|425|375|475", "type": "MC", "units" : "", "marks" : 1})
questionsY3Progress1.push({ "question" : "What number should replace H on the number line?", "answer" : "775|825|750|725", "type": "MC", "units" : "", "marks" : 1})
questionsY3Progress1.push({ "question" : "What number should replace I?", "answer" : "300", "type": "NP", "units" : "", "marks" : 1})
questionsY3Progress1.push({ "question" : "What number should replace J?", "answer" : "500", "type": "NP", "units" : "", "marks" : 1})
questionsY3Progress1.push({ "question" : "What number should replace K?", "answer" : "750", "type": "NP", "units" : "", "marks" : 1})
questionsY3Progress1.push({ "question" : "What number should replace L?", "answer" : "760", "type": "NP", "units" : "", "marks" : 1})

var questionsY3Progress2 = [];


questionsY3Progress2.push({ "question" : "Emile has 9 gold gems and 4 silver gems. How many gold and silver gems does Emile have altogether?", "answer" : "13", "type": "NP", "units" : "gems", "marks" : 1})
questionsY3Progress2.push({ "question" : "Emile had £14. Then they spent £7. How much money does Emile have now?", "answer" : "7", "type": "NP", "units" : "£", "marks" : 1})
questionsY3Progress2.push({ "question" : "What is the missing number?", "answer" : "55", "type": "NP", "units" : "", "marks" : 1})
questionsY3Progress2.push({ "question" : "What is the missing number?", "answer" : "78", "type": "NP", "units" : "", "marks" : 1})
questionsY3Progress2.push({ "question" : "What is the missing number?", "answer" : "53", "type": "NP", "units" : "", "marks" : 1})
questionsY3Progress2.push({ "question" : "What is the missing number?", "answer" : "37", "type": "NP", "units" : "", "marks" : 1})
questionsY3Progress2.push({ "question" : "Emile has 100 gems. 17 are silver gems. How many gems does Emile have that are not silver?", "answer" : "83", "type": "NP", "units" : "gems", "marks" : 1})
questionsY3Progress2.push({ "question" : "What is the missing value?", "answer" : "57", "type": "NP", "units" : "", "marks" : 1})
questionsY3Progress2.push({ "question" : "Find the missing number using columnar methods.", "answer" : "1141", "type": "NP", "units" : "", "marks" : 1})
questionsY3Progress2.push({ "question" : "Find the missing number using columnar methods.", "answer" : "1221", "type": "NP", "units" : "", "marks" : 1})
questionsY3Progress2.push({ "question" : "Find the missing number using columnar methods.", "answer" : "139", "type": "NP", "units" : "", "marks" : 1})
questionsY3Progress2.push({ "question" : "Find the missing number using columnar methods.", "answer" : "210", "type": "NP", "units" : "", "marks" : 1})
questionsY3Progress2.push({ "question" : "Find the missing number using columnar methods.", "answer" : "330", "type": "NP", "units" : "", "marks" : 1})
questionsY3Progress2.push({ "question" : "Find the missing number using columnar methods.", "answer" : "375", "type": "NP", "units" : "", "marks" : 1})
questionsY3Progress2.push({ "question" : "Find the missing number using columnar methods.", "answer" : "515", "type": "NP", "units" : "", "marks" : 1})
questionsY3Progress2.push({ "question" : "Find the missing number using columnar methods.", "answer" : "250", "type": "NP", "units" : "", "marks" : 1})



  var questionsY4Progress1 = [];
  questionsY4Progress1.push({ "question" : "1,000 is ten times the size of….", "answer" : "100|10|10000|1000", "type": "MC", "units" : "", "marks" : 1})
questionsY4Progress1.push({ "question" : "1,700 is ten times the size of….", "answer" : "170", "type": "NP", "units" : "", "marks" : 1})
questionsY4Progress1.push({ "question" : "Emile sells 17 gems for £100 each. How much money has Emile taken?", "answer" : "1700", "type": "NP", "units" : "£", "marks" : 1})
questionsY4Progress1.push({ "question" : "Scrambler sells 43 gems for £100 each. How much money does Scrambler take?", "answer" : "4300", "type": "NP", "units" : "£", "marks" : 1})
questionsY4Progress1.push({ "question" : "Emile's rocket  weighs 900kg. Scrambler's rocket weighs 10 times as much. What is the weight of Scrambler's rocket?", "answer" : "9000", "type": "NP", "units" : "kg", "marks" : 1})
questionsY4Progress1.push({ "question" : "Which numbers are all multiples of 100?", "answer" : "7,500  8,900 3,500 2,100|7,500 8,950 3,500  2,100|7,500  8,900  3,540  2,100|7,500  8,900  3,500  2,120", "type": "MC", "units" : "", "marks" : 1})
questionsY4Progress1.push({ "question" : "What number is represented by the counters?", "answer" : "9567", "type": "NP", "units" : "", "marks" : 1})
questionsY4Progress1.push({ "question" : "What number is represented by the table?", "answer" : "4231", "type": "NP", "units" : "", "marks" : 1})
questionsY4Progress1.push({ "question" : "What number is represented by the part whole model?", "answer" : "6824", "type": "NP", "units" : "", "marks" : 1})
questionsY4Progress1.push({ "question" : "What is the missing number?", "answer" : "6423", "type": "NP", "units" : "", "marks" : 1})
questionsY4Progress1.push({ "question" : "What is the missing number?", "answer" : "3462", "type": "NP", "units" : "", "marks" : 1})
questionsY4Progress1.push({ "question" : "What is the missing number?", "answer" : "4236", "type": "NP", "units" : "", "marks" : 1})
questionsY4Progress1.push({ "question" : "What is the missing number?", "answer" : "362", "type": "NP", "units" : "", "marks" : 1})
questionsY4Progress1.push({ "question" : "Emile has found 3,000 gems. There are 7,690 gems. How many more gems can Emile find?", "answer" : "4690", "type": "NP", "units" : "", "marks" : 1})
questionsY4Progress1.push({ "question" : "What number should replace A on the number line?", "answer" : "6250|6225|6275|6210", "type": "MC", "units" : "", "marks" : 1})
questionsY4Progress1.push({ "question" : "What number should replace B on the number line?", "answer" : "6315|6350|6325|6305", "type": "MC", "units" : "", "marks" : 1})
questionsY4Progress1.push({ "question" : "What number should replace C on the number line?", "answer" : "6560|6550|6575|6600", "type": "MC", "units" : "", "marks" : 1})
questionsY4Progress1.push({ "question" : "What number should replace D?", "answer" : "2780", "type": "NP", "units" : "", "marks" : 1})
questionsY4Progress1.push({ "question" : "What number should replace E?", "answer" : "6250", "type": "NP", "units" : "", "marks" : 1})
questionsY4Progress1.push({ "question" : "What number should replace F?", "answer" : "6350", "type": "NP", "units" : "", "marks" : 1})
questionsY4Progress1.push({ "question" : "What number should replace G?", "answer" : "6997", "type": "NP", "units" : "", "marks" : 1})
questionsY4Progress1.push({ "question" : "What number should replace H?", "answer" : "6998", "type": "NP", "units" : "", "marks" : 1})
questionsY4Progress1.push({ "question" : "Estimate how much liquid is in the beaker.", "answer" : "200ml|400ml|500ml|50ml", "type": "MC", "units" : "", "marks" : 1})
questionsY4Progress1.push({ "question" : "What is the missing number?", "answer" : "10", "type": "NP", "units" : "", "marks" : 1})
questionsY4Progress1.push({ "question" : "What is the missing number?", "answer" : "25", "type": "NP", "units" : "", "marks" : 1})
questionsY4Progress1.push({ "question" : "What is the missing number?", "answer" : "4", "type": "NP", "units" : "", "marks" : 1})
questionsY4Progress1.push({ "question" : "What is the missing number?", "answer" : "250", "type": "NP", "units" : "", "marks" : 1})
questionsY4Progress1.push({ "question" : "Emile has travelled 200m. How much further do they need to go to travel 4,000m?", "answer" : "3800", "type": "NP", "units" : "m", "marks" : 1})
questionsY4Progress1.push({ "question" : "1,000 litres of fuel is shared between 4 rockets. How much fuel does each rocket receive?", "answer" : "250", "type": "NP", "units" : "l", "marks" : 1})

var questionsY4Progress2 = [];
  
questionsY4Progress2.push({ "question" : "What is the missing number?", "answer" : "1700", "type": "NP", "units" : "", "marks" : 1})
questionsY4Progress2.push({ "question" : "What is the missing number?", "answer" : "65", "type": "NP", "units" : "", "marks" : 1})
questionsY4Progress2.push({ "question" : "What is the missing number?", "answer" : "130", "type": "NP", "units" : "", "marks" : 1})
questionsY4Progress2.push({ "question" : "What is the missing number?", "answer" : "23", "type": "NP", "units" : "", "marks" : 1})
questionsY4Progress2.push({ "question" : "Scrambler has 19 gems. Emile has 100 times as many gems as Scrambler. How many gems does Emile have?", "answer" : "1900", "type": "NP", "units" : "", "marks" : 1})
questionsY4Progress2.push({ "question" : "If 16 x 18 = 288, which other number statement is also true?", "answer" : "288 ÷ 16 = 18|288 ÷ 18 = 18|18 ÷ 16 = 288|288 x 16 = 18", "type": "MC", "units" : "", "marks" : 1})
questionsY4Progress2.push({ "question" : "If 162 x 198 = 32,076, which other number statement is also true?", "answer" : "198 x 162 = 32,076|198 ÷ 162 = 32,076|162 ÷ 198 = 32,076|32,076 ÷ 198 = 198", "type": "MC", "units" : "", "marks" : 1})


  var questionsY5Progress1 = [];
  questionsY5Progress1.push({ "question" : "What is the value of A?", "answer" : "20.7", "type": "NP", "units" : "", "marks" : 1})
  questionsY5Progress1.push({ "question" : "What is the value of B?", "answer" : "7", "type": "NP", "units" : "", "marks" : 1})
  questionsY5Progress1.push({ "question" : "What is the value of C?", "answer" : "6280", "type": "NP", "units" : "", "marks" : 1})
  questionsY5Progress1.push({ "question" : "What is the value of D?", "answer" : "32.75", "type": "NP", "units" : "", "marks" : 1})
  questionsY5Progress1.push({ "question" : "What is the missing number?", "answer" : "0.07", "type": "NP", "units" : "", "marks" : 1})
  questionsY5Progress1.push({ "question" : "What is the missing number?", "answer" : "0.5", "type": "NP", "units" : "", "marks" : 1})
  questionsY5Progress1.push({ "question" : "What is the missing number?", "answer" : "85", "type": "NP", "units" : "", "marks" : 1})
  questionsY5Progress1.push({ "question" : "What is the missing number?", "answer" : "8.9", "type": "NP", "units" : "", "marks" : 1})
  questionsY5Progress1.push({ "question" : "What is the missing number?", "answer" : "9.52", "type": "NP", "units" : "", "marks" : 1})
  questionsY5Progress1.push({ "question" : "What is the missing number?", "answer" : "9.2", "type": "NP", "units" : "", "marks" : 1})
  questionsY5Progress1.push({ "question" : "What is the missing number?", "answer" : "952", "type": "NP", "units" : "", "marks" : 1})
  questionsY5Progress1.push({ "question" : "What is the missing number?", "answer" : "67.8", "type": "NP", "units" : "", "marks" : 1})
  questionsY5Progress1.push({ "question" : "Which number is a multiple of both 3 and 7?", "answer" : "42|49|48|43", "type": "MC", "units" : "", "marks" : 1})
  questionsY5Progress1.push({ "question" : "Which numbers are multiples of 3?", "answer" : "15, 21, 27|15, 24, 28|16, 24, 27|15, 23, 27", "type": "MC", "units" : "", "marks" : 1})
  questionsY5Progress1.push({ "question" : "What number is a multiple of 3 and 4 and less than 20?", "answer" : "12", "type": "NP", "units" : "", "marks" : 1})

  var questionsY5Progress2 = [];

questionsY5Progress2.push({ "question" : "Fill in the missing number.", "answer" : "1", "type": "NP", "units" : "", "marks" : 1})
questionsY5Progress2.push({ "question" : "Fill in the missing number.", "answer" : "0.28", "type": "NP", "units" : "", "marks" : 1})
questionsY5Progress2.push({ "question" : "Which numbers when added together sum to 0.17?", "answer" : "0.08 & 0.09|0.1 & 0.7|0.8 & 0.9|0.8 & 0.09", "type": "MC", "units" : "", "marks" : 1})
questionsY5Progress2.push({ "question" : "Is the following number sentence correct or incorrect?", "answer" : "Correct|Incorrect", "type": "MC", "units" : "", "marks" : 1})
questionsY5Progress2.push({ "question" : "Is the following number sentence correct or incorrect?", "answer" : "Incorrect|Correct", "type": "MC", "units" : "", "marks" : 1})
questionsY5Progress2.push({ "question" : "Is the following number sentence correct or incorrect?", "answer" : "Incorrect|Correct", "type": "MC", "units" : "", "marks" : 1})
questionsY5Progress2.push({ "question" : "Complete the number sentence:", "answer" : "1012", "type": "NP", "units" : "", "marks" : 1})
questionsY5Progress2.push({ "question" : "Complete the number sentence:", "answer" : "9372", "type": "NP", "units" : "", "marks" : 1})
questionsY5Progress2.push({ "question" : "Complete the number sentence:", "answer" : "11012", "type": "NP", "units" : "", "marks" : 1})
questionsY5Progress2.push({ "question" : "Complete the number sentence:", "answer" : "509", "type": "NP", "units" : "", "marks" : 1})
questionsY5Progress2.push({ "question" : "Complete the number sentence:", "answer" : "613", "type": "NP", "units" : "", "marks" : 1})


  
  var questionsY6Progress1 = [];
  questionsY6Progress1.push({ "question" : "200 made 1,000 times bigger is…..", "answer" : "200000", "type": "NP", "units" : "", "marks" : 1})
questionsY6Progress1.push({ "question" : "0.8 made 100 times bigger is…..", "answer" : "80", "type": "NP", "units" : "", "marks" : 1})
questionsY6Progress1.push({ "question" : "300,000 made 10 times bigger is….", "answer" : "3000000", "type": "NP", "units" : "", "marks" : 1})
questionsY6Progress1.push({ "question" : "3,000,000 made one-thousandth times the size is…..", "answer" : "3000", "type": "NP", "units" : "", "marks" : 1})
questionsY6Progress1.push({ "question" : "7,000 made one-hundredth times the size is…..", "answer" : "70", "type": "NP", "units" : "", "marks" : 1})
questionsY6Progress1.push({ "question" : "9 made one-tenth times the size is…..", "answer" : "0.9", "type": "NP", "units" : "", "marks" : 1})
questionsY6Progress1.push({ "question" : "There are approximately 700 gems on the rocket. The number of gems on the planet is about 100 times as many. Approximately how gems are there on the planet?", "answer" : "70000", "type": "NP", "units" : "gems", "marks" : 1})
questionsY6Progress1.push({ "question" : "What is the value of A?", "answer" : "3590", "type": "NP", "units" : "", "marks" : 1})
questionsY6Progress1.push({ "question" : "What is the value of the digit 7 in 563,723?", "answer" : "700", "type": "NP", "units" : "", "marks" : 1})
questionsY6Progress1.push({ "question" : "What is the value of the digit 7 in 2,367,123?", "answer" : "7000", "type": "NP", "units" : "", "marks" : 1})
questionsY6Progress1.push({ "question" : "What is the value of the digit 7 in 7,456,238?", "answer" : "7000000", "type": "NP", "units" : "", "marks" : 1})
questionsY6Progress1.push({ "question" : "The numbers below all have the digit 9 once. Which number has the digit 9 where is has the value of 9 million?", "answer" : "9125845|1259845|1125945|1195845", "type": "MC", "units" : "", "marks" : 1})
questionsY6Progress1.push({ "question" : "The numbers below all have the digit 9 once. Which number has the digit 9 where is has the value of 9 thousand?", "answer" : "1259845|9125845|1125945|1195845", "type": "MC", "units" : "", "marks" : 1})
questionsY6Progress1.push({ "question" : "The numbers below all have the digit 9 once. Which number has the digit 9 where is has the value of 9 hundred?", "answer" : "1125945|1259845|9125845|1195845", "type": "MC", "units" : "", "marks" : 1})
questionsY6Progress1.push({ "question" : "The numbers below all have the digit 9 once. Which number has the digit 9 where is has the value of 9 thousand?", "answer" : "1259845|1125945|9125845|1195845", "type": "MC", "units" : "", "marks" : 1})
questionsY6Progress1.push({ "question" : "What is the missing symbol?", "answer" : "<|>|=|&", "type": "MC", "units" : "", "marks" : 1})
questionsY6Progress1.push({ "question" : "What is the missing symbol?", "answer" : ">|<|=|%", "type": "MC", "units" : "", "marks" : 1})
questionsY6Progress1.push({ "question" : "What is the missing symbol?", "answer" : "<|>|=|&", "type": "MC", "units" : "", "marks" : 1})
questionsY6Progress1.push({ "question" : "Which letter represents 4,250,000 on the number line?", "answer" : "B|C|D|A", "type": "MC", "units" : "", "marks" : 1})
questionsY6Progress1.push({ "question" : "What is the value of E?", "answer" : "2581564", "type": "NP", "units" : "", "marks" : 1})
questionsY6Progress1.push({ "question" : "What is the value of F?", "answer" : "4581564", "type": "NP", "units" : "", "marks" : 1})
questionsY6Progress1.push({ "question" : "What is the value of G?", "answer" : "2751009", "type": "NP", "units" : "", "marks" : 1})
questionsY6Progress1.push({ "question" : "What is the value of H?", "answer" : "2951009", "type": "NP", "units" : "", "marks" : 1})
questionsY6Progress1.push({ "question" : "Emile's rocket holds approximately 63,000 litres of fuel. The capacity of the fuel tank has been rounded to the nearest multiple of 1,000. The minimum amount of fuel the fuel tank could hold is….", "answer" : "62500", "type": "NP", "units" : "litres", "marks" : 1})
questionsY6Progress1.push({ "question" : "Emile's rocket holds approximately 63,000 litres of fuel. The capacity of the fuel tank has been rounded to the nearest multiple of 1,000. The maximum amount of fuel the fuel tank could hold is….", "answer" : "63499", "type": "NP", "units" : "litres", "marks" : 1})
questionsY6Progress1.push({ "question" : "What is the missing number?", "answer" : "120", "type": "NP", "units" : "", "marks" : 1})
questionsY6Progress1.push({ "question" : "What is the missing number?", "answer" : "25", "type": "NP", "units" : "", "marks" : 1})
questionsY6Progress1.push({ "question" : "What is the missing number?", "answer" : "9.9", "type": "NP", "units" : "", "marks" : 1})
questionsY6Progress1.push({ "question" : "What is the missing number?", "answer" : "100", "type": "NP", "units" : "", "marks" : 1})
questionsY6Progress1.push({ "question" : "What is the value of I?", "answer" : "0.5", "type": "NP", "units" : "", "marks" : 1})
questionsY6Progress1.push({ "question" : "What is the value of J?", "answer" : "1.5", "type": "NP", "units" : "", "marks" : 1})
questionsY6Progress1.push({ "question" : "What is the value of K?", "answer" : "4", "type": "NP", "units" : "", "marks" : 1})
questionsY6Progress1.push({ "question" : "What is the value of L?", "answer" : "2500", "type": "NP", "units" : "", "marks" : 1})
questionsY6Progress1.push({ "question" : "What is the value of M?", "answer" : "16000", "type": "NP", "units" : "", "marks" : 1})
questionsY6Progress1.push({ "question" : "What is the value of N?", "answer" : "320000", "type": "NP", "units" : "", "marks" : 1})
questionsY6Progress1.push({ "question" : "If 3,071 ÷ 37 = 83, what is the missing value from 83 x □ = 30,710?", "answer" : "370", "type": "NP", "units" : "", "marks" : 1})
questionsY6Progress1.push({ "question" : "If 634 + 242 = 876, what is the missing value from □ + 24.2 = 87.6?", "answer" : "63.4", "type": "NP", "units" : "", "marks" : 1})
questionsY6Progress1.push({ "question" : "If 634 + 242 = 876, what is the missing value from 8,760 - □ = 2,420?", "answer" : "6340", "type": "NP", "units" : "", "marks" : 1})
questionsY6Progress1.push({ "question" : "If 634 + 242 = 876, what is the missing value from 88,600 - 64,400 = □?", "answer" : "24200", "type": "NP", "units" : "", "marks" : 1})
questionsY6Progress1.push({ "question" : "What is the missing value?", "answer" : "251", "type": "NP", "units" : "", "marks" : 1})
questionsY6Progress1.push({ "question" : "What is the missing value?", "answer" : "192", "type": "NP", "units" : "", "marks" : 1})
  
var questionsY6Progress2 = [];

questionsY6Progress2.push({ "question" : "Select the simplest form of the fraction below:", "answer" : "1/5|3/15|2/10|1/15", "type": "MC", "units" : "", "marks" : 1})
questionsY6Progress2.push({ "question" : "Select the simplest form of the fraction below:", "answer" : "3/5|1/5|9/15|3/1", "type": "MC", "units" : "", "marks" : 1})
questionsY6Progress2.push({ "question" : "Select the simplest form of the fraction below:", "answer" : "1/4|1/5|5/4|4/20", "type": "MC", "units" : "", "marks" : 1})
questionsY6Progress2.push({ "question" : "Select the simplest form of the fraction below:", "answer" : "2/3|6/9|5/9|4/20", "type": "MC", "units" : "", "marks" : 1})
questionsY6Progress2.push({ "question" : "Select the simplest form of the fraction below:", "answer" : "11/20|1/2|1.1/2|3/5", "type": "MC", "units" : "", "marks" : 1})
questionsY6Progress2.push({ "question" : "Work out which is the largest fraction by simplifying them to unit fractions?", "answer" : "4/8|5/20|3/18|9/27", "type": "MC", "units" : "", "marks" : 1})
questionsY6Progress2.push({ "question" : "Solve the below calculation, choosing the simplest form.", "answer" : "1/2|4/8|2/3|3/4", "type": "MC", "units" : "", "marks" : 1})
questionsY6Progress2.push({ "question" : "Solve the below calculation, choosing the simplest form.", "answer" : "1/3|1/2|3/9|3/4", "type": "MC", "units" : "", "marks" : 1})
questionsY6Progress2.push({ "question" : "Solve the below calculation, choosing the simplest form.", "answer" : "10/13|2/3|1/13|3/13", "type": "MC", "units" : "", "marks" : 1})
questionsY6Progress2.push({ "question" : "Select the missing symbols (<, > or =). (You may need to simplify the fractions.)", "answer" : "<|>|=", "type": "MC", "units" : "", "marks" : 1})
questionsY6Progress2.push({ "question" : "Select the missing symbols (<, > or =). (You may need to simplify the fractions.)", "answer" : ">|<|=", "type": "MC", "units" : "", "marks" : 1})
questionsY6Progress2.push({ "question" : "Select the missing symbols (<, > or =). (You may need to simplify the fractions.)", "answer" : ">|<|=", "type": "MC", "units" : "", "marks" : 1})
questionsY6Progress2.push({ "question" : "Emile has 2/3 of a full fuel tank (10,000 litres). Scrambler has 5/9 of a full fuel tank (also 10,000 litres). Who has the most fuel?", "answer" : "Emile|Scrambler", "type": "MC", "units" : "", "marks" : 1})
questionsY6Progress2.push({ "question" : "Which is the largest fraction?", "answer" : "2/5|4/20|1/4|3/10", "type": "MC", "units" : "", "marks" : 1})
questionsY6Progress2.push({ "question" : "Which is the smallest fraction?", "answer" : "4/20|2/5|1/4|3/10", "type": "MC", "units" : "", "marks" : 1})
questionsY6Progress2.push({ "question" : "Which number could go in the box to make the statement true?", "answer" : "5|2|7|8", "type": "MC", "units" : "", "marks" : 1})
questionsY6Progress2.push({ "question" : "Select the missing symbols (<, > or =).", "answer" : "<|>|=", "type": "MC", "units" : "", "marks" : 1})
questionsY6Progress2.push({ "question" : "Select the missing symbols (<, > or =).", "answer" : ">|<|=", "type": "MC", "units" : "", "marks" : 1})


var questionsY1Progress3 = [];

questionsY1Progress3.push({ "question" : "Complete the number sentence 5 + 3 = □ to show what's happening.", "answer" : "8", "type": "NP", "units" : "", "marks" : 1})
questionsY1Progress3.push({ "question" : "There are 6 gems. The gems are either red or blue gems. 3 of the gems are red. How many gems are blue?", "answer" : "3", "type": "NP", "units" : "", "marks" : 1})
questionsY1Progress3.push({ "question" : "Which number sentence shows how many pieces of fruit there is altogether?", "answer" : "7 = 4 + 3|3 + 3 = 6|3 + 4 = 8|6 = 3 + 4", "type": "MC", "units" : "", "marks" : 1})


var questionsY2Progress3 = [];

questionsY2Progress3.push({ "question" : "Which number sentence describes the equal groups shown?", "answer" : "5 + 5 + 5 = 15|3 + 3 + 3 + 3 + 3 + 3 = 15|5 + 5 = 10|6 + 6 + 6 = 18", "type": "MC", "units" : "", "marks" : 1})
questionsY2Progress3.push({ "question" : "Which number sentence describes the equal groups shown?", "answer" : "15 = 3 x 5|5 x 3 = 18|15 = 5 x 5|5 x 3 = 16", "type": "MC", "units" : "", "marks" : 1})
questionsY2Progress3.push({ "question" : "Gems come in boxes of 10. Emile needs 50 gems. How many boxes of gems does Emile need?", "answer" : "5", "type": "NP", "units" : "", "marks" : 1})
questionsY2Progress3.push({ "question" : "There are 5 green gems in each room. How many green gems are there in 8 rooms?", "answer" : "40", "type": "NP", "units" : "", "marks" : 1})



var questionsY3Progress3 = [];

questionsY3Progress3.push({ "question" : "What is the value of A?", "answer" : "80", "type": "NP", "units" : "", "marks" : 1})
questionsY3Progress3.push({ "question" : "What is the value of B?", "answer" : "40", "type": "NP", "units" : "", "marks" : 1})
questionsY3Progress3.push({ "question" : "What is the value of C?", "answer" : "25", "type": "NP", "units" : "", "marks" : 1})
questionsY3Progress3.push({ "question" : "What is the value of D?", "answer" : "75", "type": "NP", "units" : "", "marks" : 1})
questionsY3Progress3.push({ "question" : "Emile counts from 0 in multiples of 25. Which numbers will he say?", "answer" : "100; 25; 275; 450|100; 25; 275; 455|100; 155; 275; 450|100; 155; 275; 455", "type": "MC", "units" : "", "marks" : 1})
questionsY3Progress3.push({ "question" : "Complete the missing number to make the number sentence correct.", "answer" : "25", "type": "NP", "units" : "", "marks" : 1})
questionsY3Progress3.push({ "question" : "Complete the missing number to make the number sentence correct.", "answer" : "2", "type": "NP", "units" : "", "marks" : 1})


var questionsY4Progress3 = [];

questionsY4Progress3.push({ "question" : "What is the missing symbol?", "answer" : "=|<|>", "type": "MC", "units" : "", "marks" : 1})
questionsY4Progress3.push({ "question" : "What is the missing symbol?", "answer" : ">|<|=", "type": "MC", "units" : "", "marks" : 1})
questionsY4Progress3.push({ "question" : "What is the missing symbol?", "answer" : "=|<|>", "type": "MC", "units" : "", "marks" : 1})
questionsY4Progress3.push({ "question" : "What is the missing symbol?", "answer" : "=|<|>", "type": "MC", "units" : "", "marks" : 1})
questionsY4Progress3.push({ "question" : "A box of orange gems costs £9. How much does 18 boxes cost?", "answer" : "162", "type": "NP", "units" : "£", "marks" : 1})
questionsY4Progress3.push({ "question" : "A page of paper is covered in rows and columns making rectangles. There are 8 rows and 7 columns. How many rectangles are there on the piece of paper?", "answer" : "56", "type": "NP", "units" : "rectangles", "marks" : 1})
questionsY4Progress3.push({ "question" : "Which of these division calculations have the answer of 4 r 3?", "answer" : "19 ÷ 4|26 ÷ 6|30 ÷ 7|28 ÷ 6", "type": "MC", "units" : "", "marks" : 1})
questionsY4Progress3.push({ "question" : "Does this calculation have a remainder?", "answer" : "Yes|No", "type": "MC", "units" : "", "marks" : 1})
questionsY4Progress3.push({ "question" : "Does this calculation have a remainder?", "answer" : "No|Yes", "type": "MC", "units" : "", "marks" : 1})
questionsY4Progress3.push({ "question" : "Does this calculation have a remainder?", "answer" : "No|Yes", "type": "MC", "units" : "", "marks" : 1})
questionsY4Progress3.push({ "question" : "Does this calculation have a remainder?", "answer" : "Yes|No", "type": "MC", "units" : "", "marks" : 1})
questionsY4Progress3.push({ "question" : "Purple gems come in boxes of 8. How many boxes of purple gems does Emile need, if they want 60 purple gems?", "answer" : "8|6|7|5", "type": "MC", "units" : "boxes", "marks" : 1})
questionsY4Progress3.push({ "question" : "If 35 ÷ 7 = 5, then what does 3,500 ÷ 700 equal?", "answer" : "5", "type": "NP", "units" : "", "marks" : 1})
questionsY4Progress3.push({ "question" : "If 35 ÷ 7 = 5, then what does 3,500 ÷ 7 equal?", "answer" : "500", "type": "NP", "units" : "", "marks" : 1})
questionsY4Progress3.push({ "question" : "Emile flew his rocket around the planet 4 times. The distance around the planet is 9 million kilometres. How far did Emile fly?", "answer" : "36", "type": "NP", "units" : "million kilometres", "marks" : 1})
questionsY4Progress3.push({ "question" : "If 6 x 7 = 42, then what does 600 x 7 equal?", "answer" : "4200", "type": "NP", "units" : "", "marks" : 1})





var questionsY5Progress3 = [];
questionsY5Progress3.push({ "question" : "What is 3/5 of 15?", "answer" : "9", "type": "NP", "units" : "", "marks" : 1})
questionsY5Progress3.push({ "question" : "What is 2/7 of 28?", "answer" : "8", "type": "NP", "units" : "", "marks" : 1})
questionsY5Progress3.push({ "question" : "What is 6/9 of 45?", "answer" : "30", "type": "NP", "units" : "", "marks" : 1})
questionsY5Progress3.push({ "question" : "Emile bought 21 litres of paint and used 2/3 of it decorating their rocket. How much paint has Emile used?", "answer" : "14", "type": "NP", "units" : "litres", "marks" : 1})
questionsY5Progress3.push({ "question" : "Which fraction is equivalent to 1/3?", "answer" : "4/12|3/12|6/15|3/10", "type": "MC", "units" : "", "marks" : 1})
questionsY5Progress3.push({ "question" : "Which fraction is equivalent to 1/4?", "answer" : "3/12|4/12|6/15|4/10", "type": "MC", "units" : "", "marks" : 1})
questionsY5Progress3.push({ "question" : "Which fraction is equivalent to 1/3?", "answer" : "5/15|3/15|6/15|5/10", "type": "MC", "units" : "", "marks" : 1})
questionsY5Progress3.push({ "question" : "Where would 30/36 go on the number line below? (Hint: convert it into sixths)", "answer" : "D|A|B|C", "type": "MC", "units" : "", "marks" : 1})
questionsY5Progress3.push({ "question" : "What fraction is represented in the place value grid?", "answer" : "7/10|7/100|7|70", "type": "MC", "units" : "", "marks" : 1})
questionsY5Progress3.push({ "question" : "What is the missing symbol?", "answer" : "=|<|>", "type": "MC", "units" : "", "marks" : 1})
questionsY5Progress3.push({ "question" : "What is the missing symbol?", "answer" : ">|<|=", "type": "MC", "units" : "", "marks" : 1})
questionsY5Progress3.push({ "question" : "What is the missing symbol?", "answer" : "=|<|>", "type": "MC", "units" : "", "marks" : 1})
questionsY5Progress3.push({ "question" : "What fraction is represented by the shaded area of the bar?", "answer" : "2/5|1/5|2/6|1/3", "type": "MC", "units" : "", "marks" : 1})
questionsY5Progress3.push({ "question" : "What decimal is represented by the shaded area of the bar?", "answer" : "0.4", "type": "NP", "units" : "", "marks" : 1})
questionsY5Progress3.push({ "question" : "What is the missing number?", "answer" : "10", "type": "NP", "units" : "", "marks" : 1})
questionsY5Progress3.push({ "question" : "What is the missing number?", "answer" : "100", "type": "NP", "units" : "", "marks" : 1})
questionsY5Progress3.push({ "question" : "What is the missing number?", "answer" : "10", "type": "NP", "units" : "", "marks" : 1})
questionsY5Progress3.push({ "question" : "What is the decimal equivalent of 3/100?", "answer" : "0.03", "type": "NP", "units" : "", "marks" : 1})
questionsY5Progress3.push({ "question" : "What is the decimal equivalent of 13/100?", "answer" : "0.13", "type": "NP", "units" : "", "marks" : 1})
questionsY5Progress3.push({ "question" : "Which is the fraction equivalent to 0.31?", "answer" : "31/100|31/10|31/1000|1/31", "type": "MC", "units" : "", "marks" : 1})
questionsY5Progress3.push({ "question" : "Which is the fraction equivalent to 0.3?", "answer" : "3/10|3/100|3/1|1/3", "type": "MC", "units" : "", "marks" : 1})
questionsY5Progress3.push({ "question" : "What number is made up of 1 one, 1 tenth and 1 hundredth?", "answer" : "1.11", "type": "NP", "units" : "", "marks" : 1})
questionsY5Progress3.push({ "question" : "What is the missing number?", "answer" : "5.83", "type": "NP", "units" : "", "marks" : 1})
questionsY5Progress3.push({ "question" : "What is the missing number?", "answer" : "80.53", "type": "NP", "units" : "", "marks" : 1})
questionsY5Progress3.push({ "question" : "What is the missing number?", "answer" : "58.03", "type": "NP", "units" : "", "marks" : 1})
questionsY5Progress3.push({ "question" : "What is the missing number?", "answer" : "500.83", "type": "NP", "units" : "", "marks" : 1})
questionsY5Progress3.push({ "question" : "What is the missing number?", "answer" : "0.86", "type": "NP", "units" : "", "marks" : 1})
questionsY5Progress3.push({ "question" : "What number is A pointing to on the number line?", "answer" : "0.24", "type": "NP", "units" : "", "marks" : 1})
questionsY5Progress3.push({ "question" : "What number is B pointing to on the number line?", "answer" : "0.48", "type": "NP", "units" : "", "marks" : 1})
questionsY5Progress3.push({ "question" : "What is the missing symbol?", "answer" : "=|<|>", "type": "MC", "units" : "", "marks" : 1})
questionsY5Progress3.push({ "question" : "What is the missing symbol?", "answer" : ">|<|=", "type": "MC", "units" : "", "marks" : 1})
questionsY5Progress3.push({ "question" : "What is the missing symbol?", "answer" : "<|>|=", "type": "MC", "units" : "", "marks" : 1})
questionsY5Progress3.push({ "question" : "Look at the table. Whose rocket is tallest?", "answer" : "Emile's|Aimme's|Scrambler's", "type": "MC", "units" : "", "marks" : 1})


var questionsY1Progress4 = [];
questionsY1Progress4.push({ "question" : "What is A?", "answer" : "33", "type": "NP", "units" : "", "marks" : 1})
questionsY1Progress4.push({ "question" : "What is B?", "answer" : "34", "type": "NP", "units" : "", "marks" : 1})
questionsY1Progress4.push({ "question" : "What is C?", "answer" : "36", "type": "NP", "units" : "", "marks" : 1})
questionsY1Progress4.push({ "question" : "What is D?", "answer" : "49", "type": "NP", "units" : "", "marks" : 1})
questionsY1Progress4.push({ "question" : "What is E?", "answer" : "51", "type": "NP", "units" : "", "marks" : 1})


var questionsY2Progress4 = [];
questionsY2Progress4.push({ "question" : "Which shapes have 5 vertices?", "answer" : "A and C|A and B|C and D|B and C", "type": "MC", "units" : "", "marks" : 1})
questionsY2Progress4.push({ "question" : "Which shapes have 6 sides?", "answer" : "B and C|B and D|A and C|A and B", "type": "MC", "units" : "", "marks" : 1})
questionsY2Progress4.push({ "question" : "Which shape is NOT a hexagon and does NOT have an even number of sides?", "answer" : "B|A|D|C", "type": "MC", "units" : "", "marks" : 1})
questionsY2Progress4.push({ "question" : "Which shape has these faces?", "answer" : "D|A|B|C", "type": "MC", "units" : "", "marks" : 1})


var questionsY3Progress4 = [];
questionsY3Progress4.push({ "question" : "What fraction of the shape is shaded?", "answer" : "1/4|1/3|4/1|1/5", "type": "MC", "units" : "", "marks" : 1})
questionsY3Progress4.push({ "question" : "What fraction of the shape is shaded?", "answer" : "1/8|8/1|1/9|1/7", "type": "MC", "units" : "", "marks" : 1})
questionsY3Progress4.push({ "question" : "What fraction of the shape is shaded?", "answer" : "1/2|2/1|1/3|2/2", "type": "MC", "units" : "", "marks" : 1})
questionsY3Progress4.push({ "question" : "What fraction of the shape is shaded?", "answer" : "1/3|1/4|3/1|2/3", "type": "MC", "units" : "", "marks" : 1})
questionsY3Progress4.push({ "question" : "Which shape has 2/5 shaded?", "answer" : "B|A|C|D", "type": "MC", "units" : "", "marks" : 1})
questionsY3Progress4.push({ "question" : "What is 1/5 of 15?", "answer" : "3", "type": "NP", "units" : "", "marks" : 1})
questionsY3Progress4.push({ "question" : "What is 1/10 of 50?", "answer" : "5", "type": "NP", "units" : "", "marks" : 1})
questionsY3Progress4.push({ "question" : "What is 1/4 of 28?", "answer" : "7", "type": "NP", "units" : "", "marks" : 1})
questionsY3Progress4.push({ "question" : "Emile has a box of gems. 10 gems are green, 5 gems are blue and 5 gems are purple. What fraction of the gems are blue?", "answer" : "1/4|1/5|2/5|1/10", "type": "MC", "units" : "", "marks" : 1})
questionsY3Progress4.push({ "question" : "What is the value of A?", "answer" : "1/4|1/5|1/3|1/1", "type": "MC", "units" : "", "marks" : 1})
questionsY3Progress4.push({ "question" : "Which is the smallest number?", "answer" : "2/7|3/7|4/7|6/7", "type": "MC", "units" : "", "marks" : 1})






var questionsY4Progress4 = [];
questionsY4Progress4.push({ "question" : "What is the value of A on the number line?", "answer" : "3/8", "type": "NPF", "units" : "6", "marks" : 1})
questionsY4Progress4.push({ "question" : "What is the value of B on the number line?", "answer" : "7/8", "type": "NPF", "units" : "6", "marks" : 1})
questionsY4Progress4.push({ "question" : "What is the value of C on the number line?", "answer" : "5/8", "type": "NPF", "units" : "6", "marks" : 1})
questionsY4Progress4.push({ "question" : "What is the value of D on the number line?", "answer" : "4&5/7", "type": "NPFM", "units" : "", "marks" : 1})
questionsY4Progress4.push({ "question" : "What is the value of E on the number line?", "answer" : "3&2/7", "type": "NPFM", "units" : "", "marks" : 1})
questionsY4Progress4.push({ "question" : "What is the value of F on the number line?", "answer" : "5&3/7", "type": "NPFM", "units" : "", "marks" : 1})
questionsY4Progress4.push({ "question" : "Which number is larger?", "answer" : "5&5/7|5&3/7|5&4/7|5&2/7", "type": "MC", "units" : "", "marks" : 1})
questionsY4Progress4.push({ "question" : "Which number is larger?", "answer" : "5&1/3|5&1/5|5&1/7|5&1/9", "type": "MC", "units" : "", "marks" : 1})
questionsY4Progress4.push({ "question" : "Express the following improper fraction as a mixed number.", "answer" : "6&1/2", "type": "NPFM", "units" : "", "marks" : 1})
questionsY4Progress4.push({ "question" : "Express the following improper fraction as a mixed number.", "answer" : "2&5/6", "type": "NPFM", "units" : "", "marks" : 1})
questionsY4Progress4.push({ "question" : "Express the following improper fraction as a mixed number.", "answer" : "2&3/10", "type": "NPFM", "units" : "", "marks" : 1})
questionsY4Progress4.push({ "question" : "Which is the correct answer to the following calculation?", "answer" : "7/9|1&2/9|1|9/7", "type": "MC", "units" : "", "marks" : 1})
questionsY4Progress4.push({ "question" : "Which is the correct answer to the following calculation?", "answer" : "8/9|1&2/9|9/8|7/9", "type": "MC", "units" : "", "marks" : 1})
questionsY4Progress4.push({ "question" : "Which is the correct answer to the following calculation?", "answer" : "1&2/9|1&10/9|9/8|47/9", "type": "MC", "units" : "", "marks" : 1})
questionsY4Progress4.push({ "question" : "Which is the correct answer to the following calculation?", "answer" : "1|1&10/9|9/8|8/9", "type": "MC", "units" : "", "marks" : 1})
questionsY4Progress4.push({ "question" : "4|5/7 - 1|2/7 =", "answer" : "3&3/7", "type": "NPFM", "units" : "", "marks" : 1})
questionsY4Progress4.push({ "question" : "4  - 2/3 =", "answer" : "3&1/3", "type": "NPFM", "units" : "", "marks" : 1})





var questionsY5Progress4 = [];

questionsY5Progress4.push({ "question" : "What is the area of the shape drawn on square-centrimetre grid?", "answer" : "7", "type": "NP", "units" : "cm2", "marks" : 1})
questionsY5Progress4.push({ "question" : "What is the area of the shape drawn on square-centrimetre grid?", "answer" : "4", "type": "NP", "units" : "cm2", "marks" : 1})
questionsY5Progress4.push({ "question" : "What is the area of the shape drawn on square-centrimetre grid?", "answer" : "6", "type": "NP", "units" : "cm2", "marks" : 1})
questionsY5Progress4.push({ "question" : "What is the area of the shape drawn on square-centrimetre grid?", "answer" : "8", "type": "NP", "units" : "cm2", "marks" : 1})
questionsY5Progress4.push({ "question" : "Emile is tiling a wall. The tiles Emile is using are 10 cm by 10 cm. So far he has used 22 tiles. What is the area in cm2 that Emile has tiled?", "answer" : "2200", "type": "NP", "units" : "cm2", "marks" : 1})
questionsY5Progress4.push({ "question" : "Below are 4 angles. Which is the largest angle?", "answer" : "B|A|C|D", "type": "MC", "units" : "", "marks" : 1})
questionsY5Progress4.push({ "question" : "Below are 4 angles. Which is the smallest angle?", "answer" : "A|B|C|D", "type": "MC", "units" : "", "marks" : 1})


var questionsY1Progress5 = [];
questionsY1Progress5.push({ "question" : "The sticks are in bundles of 10. How many sticks are in the bundles shown?", "answer" : "40", "type": "NP", "units" : "sticks", "marks" : 1})
questionsY1Progress5.push({ "question" : "How many wheels are on the bikes shown? (Count in 2s.)", "answer" : "12", "type": "NP", "units" : "wheels", "marks" : 1})
questionsY1Progress5.push({ "question" : "Below are some 5 pence coins. How much money is shown?", "answer" : "40", "type": "NP", "units" : "p", "marks" : 1})

var questionsY1Progress6 = [];
questionsY1Progress6.push({ "question" : "What is A?", "answer" : "3", "type": "NP", "units" : "", "marks" : 1})
questionsY1Progress6.push({ "question" : "What is B?", "answer" : "8", "type": "NP", "units" : "", "marks" : 1})
questionsY1Progress6.push({ "question" : "What is C?", "answer" : "17", "type": "NP", "units" : "", "marks" : 1})
questionsY1Progress6.push({ "question" : "What is D?", "answer" : "20", "type": "NP", "units" : "", "marks" : 1})
questionsY1Progress6.push({ "question" : "What is E?", "answer" : "24", "type": "NP", "units" : "", "marks" : 1})
questionsY1Progress6.push({ "question" : "What is F?", "answer" : "39", "type": "NP", "units" : "", "marks" : 1})
questionsY1Progress6.push({ "question" : "What is G?", "answer" : "42", "type": "NP", "units" : "", "marks" : 1})
questionsY1Progress6.push({ "question" : "What is H?", "answer" : "55", "type": "NP", "units" : "", "marks" : 1})
questionsY1Progress6.push({ "question" : "What is I?", "answer" : "67", "type": "NP", "units" : "", "marks" : 1})
questionsY1Progress6.push({ "question" : "What is J?", "answer" : "79", "type": "NP", "units" : "", "marks" : 1})
questionsY1Progress6.push({ "question" : "What is K?", "answer" : "81", "type": "NP", "units" : "", "marks" : 1})
questionsY1Progress6.push({ "question" : "What is L?", "answer" : "84", "type": "NP", "units" : "", "marks" : 1})
questionsY1Progress6.push({ "question" : "What is M?", "answer" : "88", "type": "NP", "units" : "", "marks" : 1})
questionsY1Progress6.push({ "question" : "What is N?", "answer" : "93", "type": "NP", "units" : "", "marks" : 1})
questionsY1Progress6.push({ "question" : "What is O?", "answer" : "96", "type": "NP", "units" : "", "marks" : 1})
questionsY1Progress6.push({ "question" : "What is P?", "answer" : "100", "type": "NP", "units" : "", "marks" : 1})

var questionsY3Progress5 = [];
questionsY3Progress5.push({ "question" : "Complete the calculation:", "answer" : "5/9", "type": "NPF", "units" : "", "marks" : 1})
questionsY3Progress5.push({ "question" : "Complete the calculation:", "answer" : "6/7", "type": "NPF", "units" : "", "marks" : 1})
questionsY3Progress5.push({ "question" : "Complete the calculation:", "answer" : "12/13", "type": "NPF", "units" : "", "marks" : 1})
questionsY3Progress5.push({ "question" : "Complete the calculation:", "answer" : "2/5", "type": "NPF", "units" : "", "marks" : 1})
questionsY3Progress5.push({ "question" : "Complete the calculation:", "answer" : "6/11", "type": "NPF", "units" : "", "marks" : 1})
questionsY3Progress5.push({ "question" : "Emile's rocket tank was 7/10 full. He used 4/10 of the tank. How much fuel is left?", "answer" : "3/10", "type": "NPF", "units" : "", "marks" : 1})

var questionsY3Progress6 = [];
questionsY3Progress6.push({ "question" : "Which angle is a right angle?", "answer" : "B|A|C|D", "type": "MC", "units" : "", "marks" : 1})
questionsY3Progress6.push({ "question" : "Which angle is a right angle?", "answer" : "H|E|F|G", "type": "MC", "units" : "", "marks" : 1})
questionsY3Progress6.push({ "question" : "Which pair of lines are paralllel?", "answer" : "K|J|L|M", "type": "MC", "units" : "", "marks" : 1})
questionsY3Progress6.push({ "question" : "Which pair of lines are paralllel?", "answer" : "N|O|P|Q", "type": "MC", "units" : "", "marks" : 1})

var questionsY4Progress5 = [];
questionsY4Progress5.push({ "question" : "What is the co-ordinate of point A?", "answer" : "(3,4)|(4,3)|(2,4)|(4,2)", "type": "MC", "units" : "", "marks" : 1})
questionsY4Progress5.push({ "question" : "What is the co-ordinate of point B?", "answer" : "(6,5)|(5,6)|(5,5)|(5,7)", "type": "MC", "units" : "", "marks" : 1})
questionsY4Progress5.push({ "question" : "What is the co-ordinate of point C?", "answer" : "(3,1)|(1,3)|(3,2)|(2,3)", "type": "MC", "units" : "", "marks" : 1})
questionsY4Progress5.push({ "question" : "Below is the plan of a field. A fence is to be built around the edge. How many metres of fencing is needed to put a fence around the perimeter?", "answer" : "200", "type": "NP", "units" : "m", "marks" : 1})
questionsY4Progress5.push({ "question" : "What is the perimeter of the shape?", "answer" : "22", "type": "NP", "units" : "cm", "marks" : 1})
questionsY4Progress5.push({ "question" : "Is the shape shown regular or irregular?", "answer" : "regular|irregular", "type": "MC", "units" : "", "marks" : 1})

var questionsY5Progress5 = [];
questionsY5Progress5.push({ "question" : "Convert £7.62 to pence.", "answer" : "762", "type": "NP", "units" : "p", "marks" : 1})
questionsY5Progress5.push({ "question" : "Convert 6|1/2 cm to mm", "answer" : "65", "type": "NP", "units" : "mm", "marks" : 1})
questionsY5Progress5.push({ "question" : "Convert 4|3/4kg to grams.", "answer" : "4750", "type": "NP", "units" : "g", "marks" : 1})
questionsY5Progress5.push({ "question" : "Convert 7.2km to metres.", "answer" : "7200", "type": "NP", "units" : "m", "marks" : 1})
questionsY5Progress5.push({ "question" : "Convert 1.3 litres to ml", "answer" : "1300", "type": "NP", "units" : "ml", "marks" : 1})
questionsY5Progress5.push({ "question" : "Convert 465 pence to pounds.", "answer" : "4.650000", "type": "NP", "units" : "£", "marks" : 1})
questionsY5Progress5.push({ "question" : "Convert 45mm to centimetres.", "answer" : "4.500000", "type": "NP", "units" : "cm", "marks" : 1})
questionsY5Progress5.push({ "question" : "Convert 950g to kg", "answer" : "0.950000", "type": "NP", "units" : "kg", "marks" : 1})
questionsY5Progress5.push({ "question" : "Convert 5,450metres to kilometres.", "answer" : "5.450000", "type": "NP", "units" : "km", "marks" : 1})
questionsY5Progress5.push({ "question" : "Which is the largest volume?", "answer" : "650ml|1/2#                litre|0.48 litres|0.62 litres", "type": "MC", "units" : "", "marks" : 1})




//above is questions section
  
  const [questions, setQuestions] = useState([]);
  console.log(props);

  

  if (status == false){
    currQuestion = [];
    questionNum = 0;
    useranswers = [];
    //check what questions it is, checking year first will check terms later like Spring etc
    console.log(props);
    if (props.assessment_type[0] == "1" && props.assessment_type[3] == 1){
      timer = -1;
      setQuestions(questionsY1Progress1);
    } else if (props.assessment_type[0] == "2" && props.assessment_type[3] == 1){
      timer = -1;
      setQuestions(questionsY2Progress1);
    } else if (props.assessment_type[0] == "3" && props.assessment_type[3] == 1){
      timer = 1200;
      setQuestions(questionsY3Progress1);
    } else if (props.assessment_type[0] == "4" && props.assessment_type[3] == 1){
      timer = 1200;
      setQuestions(questionsY4Progress1);
    } else if (props.assessment_type[0] == "5" && props.assessment_type[3] == 1){
      timer = 1500;
      setQuestions(questionsY5Progress1);
    } else if (props.assessment_type[0] == "6" && props.assessment_type[3] == 1){
      timer = 1500;
      setQuestions(questionsY6Progress1);
    }
    else if (props.assessment_type[0] == "1" && props.assessment_type[3] == 2){
      timer = 1500;
      setQuestions(questionsY1Progress2);
    }
    else if (props.assessment_type[0] == "2" && props.assessment_type[3] == 2){
      timer = 1500;
      setQuestions(questionsY2Progress2);
    }
    else if (props.assessment_type[0] == "3" && props.assessment_type[3] == 2){
      timer = 1500;
      setQuestions(questionsY3Progress2);
    }
    else if (props.assessment_type[0] == "4" && props.assessment_type[3] == 2){
      timer = 1500;
      setQuestions(questionsY4Progress2);
    }
    else if (props.assessment_type[0] == "5" && props.assessment_type[3] == 2){
      timer = 1500;
      setQuestions(questionsY5Progress2);
    }
    else if (props.assessment_type[0] == "6" && props.assessment_type[3] == 2){
      timer = 1500;
      setQuestions(questionsY6Progress2);
    }
    else if (props.assessment_type[0] == "1" && props.assessment_type[3] == 3){
      timer = 1500;
      setQuestions(questionsY1Progress3);
    }
    else if (props.assessment_type[0] == "2" && props.assessment_type[3] == 3){
      timer = 1500;
      setQuestions(questionsY2Progress3);
    }
    else if (props.assessment_type[0] == "3" && props.assessment_type[3] == 3){
      timer = 1500;
      setQuestions(questionsY3Progress3);
    }
    else if (props.assessment_type[0] == "4" && props.assessment_type[3] == 3){
      timer = 1500;
      setQuestions(questionsY4Progress3);
    }
    else if (props.assessment_type[0] == "5" && props.assessment_type[3] == 3){
      timer = 1500;
      setQuestions(questionsY5Progress3);
    }
    else if (props.assessment_type[0] == "1" && props.assessment_type[3] == 4){
      timer = 1500;
      setQuestions(questionsY1Progress4);
    }
    else if (props.assessment_type[0] == "2" && props.assessment_type[3] == 4){
      timer = 1500;
      setQuestions(questionsY2Progress4);
    }
    else if (props.assessment_type[0] == "3" && props.assessment_type[3] == 4){
      timer = 1500;
      setQuestions(questionsY3Progress4);
    }
    else if (props.assessment_type[0] == "4" && props.assessment_type[3] == 4){
      timer = 1500;
      setQuestions(questionsY4Progress4);
    }
    else if (props.assessment_type[0] == "5" && props.assessment_type[3] == 4){
      timer = 1500;
      setQuestions(questionsY5Progress4);
    }
    else if (props.assessment_type[0] == "1" && props.assessment_type[3] == 5){
      timer = 1500;
      setQuestions(questionsY1Progress5);
    }
    else if (props.assessment_type[0] == "1" && props.assessment_type[3] == 6){
      timer = 1500;
      setQuestions(questionsY1Progress6);
    }
    else if (props.assessment_type[0] == "3" && props.assessment_type[3] == 5){
      timer = 1500;
      setQuestions(questionsY3Progress5);
    }
    else if (props.assessment_type[0] == "3" && props.assessment_type[3] == 6){
      timer = 1500;
      setQuestions(questionsY3Progress6);
    }
    else if (props.assessment_type[0] == "4" && props.assessment_type[3] == 5){
      timer = 1500;
      setQuestions(questionsY4Progress5);
    }
    else if (props.assessment_type[0] == "5" && props.assessment_type[3] == 5){
      timer = 1500;
      setQuestions(questionsY5Progress5);
    }

    setStatus(true);
  }
  console.log(questions);


  var questionMax = -1;
  if(props.minimum > 0)
  {
      questionMax = props.minimum;
  }

  function reduceTimer() {
    console.log(waitTime);
  setWaitTime(waitTime - 1);
  }


 
  console.log("question number: " + questionNum);

  /*TODO: 
  only submit at the end
  may need to scrap a lot of the core code and do it from the ground up
  create a new calculator class just for assessments
  the background image method needs to set it equal to currentquestion number

  */

  //Sets the question to a new one, currently no check for being the same question
  function newQuestion() {
    //questionNum++;
    currQuestion = questions[questionNum];
    console.log("Current question");
    console.log(currQuestion);
    console.log("Answers so far:");
    console.log(useranswers);
    setCurrentQuestion(currQuestion);
    setRefresh(!refresh);
    //CheckImage();
  }


  //Called on click
  async function checkResult(value, callback) {
    var isCorrect = true;
    if (value) {
      console.log(value.value + " " + currQuestion.correct);
      //correct answer
      if (currQuestion.correct === value.value) {
        setCorrectQuestions([...correctQuestions, currQuestion]);
        let multiplier = combo > 0 ? combo + 1 : 1;
        multiplier = multiplier > 5 ? 5 : multiplier;
        setScore(score + multiplier * 10);

        if (combo < 99) {
          setCombo(combo + 1);
        }
        if (combo > maxCombo) {
          setMaxCombo(combo);
        }

        newQuestion();
      }
      //incorrect answer
      else {
        isCorrect = false;
        setIncorrectQuestions([...incorrectQuestions, currQuestion]);
        if (combo === 0 && score >= 10) {
          setScore(score - 10);
        } else {
          setCombo(0);
        }

        let result = {
          question: currQuestion.question,
          correct: currQuestion.correct,
          incorrect: value.value
        };

        setFeedback([...feedback, result]);
        setColouredFeedback(true);
        setWaitTime(2);
      }
      //Generates a new question
      //newQuestion();

    }
  }

  function MultipleButtons() {
    console.log(currentQuestion);
    return "blank"
  }

  useEffect(() => {
    if (waitTime > 0) {
        var waitttimerID = setInterval(() => reduceTimer(), 1000);
        return () => {
            clearInterval(waitttimerID);
        };
    } else {

        setColouredFeedback(false);
        newQuestion();
    }
  },[waitTime]);

  //Set the first question, called until questions are defined
  useEffect(() => {
    if (questions !== undefined) {
      if (useranswers.length == 0 && questions.length > 0){
        for (let i = 0; i < questions.length; i++) {
          useranswers.push("");
          shuffledAnswers.push([]);
          //DO SHUFFLE QUESTIONS
          if (questions[i].type == "MC"){
            let answertext = String(questions[i].answer);
            let choices = answertext.split('|');
            shuffleArray(choices);
            shuffledAnswers[i] = choices;
          }
        }
        
        console.log("initial Answers array:")
        console.log(useranswers);
      }

      

      console.log(questions);
      var sample = questions[questionNum];
      currQuestion = sample;
      setCurrentQuestion(currQuestion);
      //CheckImage();


    }
  }, [questions]);

  //No clue
  useEffect(() => {
    if (status !== undefined && status == true) {
      setLoading(false);
    }
  }, [status]);


  function QuestionImage() {
    //IF QUESTION NUMBER GREATER THAN NUMBER OF QUESTIONS DISPLAY BLANK BACKGROUND
    if (questionNum >= questions.length){
      return blankbg;
    }
    var requireString = "Year"+props.assessment_type[0]+"/ReadyToProgress/"+props.assessment_type[3];

    requireString += "/year"+props.assessment_type[0]+"question"+(questionNum+1)+".png";
    console.log(require);
    return (require("../../assets/maths_assessments/assets/"+requireString))
}

async function setAnswer(value)
  {
    console.log("SET VALUE");
    console.log(value);
    useranswers[questionNum] = value;
    console.log(useranswers);
  }

  function NavigationButtons(){
    if (questionNum != 0 && questionNum != questions.length){
      return (
        <div>
        <NavigationButtonBack
        onClick={() => previousQuestion()}>
          <NavigationTextBack>
            Back
          </NavigationTextBack>
        </NavigationButtonBack>
        <NavigationButton
        onClick={() => nextQuestion()}>
          <NavigationText>
            Next
          </NavigationText>
        </NavigationButton>
        </div>
      );
    }else if (questionNum < questions.length){
      return (
      <div>
      <NavigationButton
      onClick={() => nextQuestion()}>
        <NavigationText>
          Next
        </NavigationText>
        
      </NavigationButton>
      </div>
      );
    }
    else{
      return (
        <div>
         <NavigationButtonBack
        onClick={() => previousQuestion()}>
          <NavigationTextBack>
            Back
          </NavigationTextBack>
        </NavigationButtonBack>

        <Button onClick={() => GameOver()} style={{fontSize: "3em", height: "100px", width: "300px", position: "relative", right: "-45%", textAlign: "center", lineHeight: "3.2"}}>
          Submit
        </Button>
        </div>
        );
    }
  }

  function PressMulti(value) {
    useranswers[questionNum] = value;
    setRefresh(!refresh);
  }

  function ConvertAnswerText(input){
    if (input.includes("&")){
      let splitValues = input.split("&");
      let wholeNumber = splitValues[0];
      let fractionSplit = splitValues[1].split("/");

      return wholeNumber.toString() + " <sup>"+ fractionSplit[0]+"</sup>&frasl;<sub>"+fractionSplit[1]+"</sub>";
    }else if (input.includes("/")){
      let fractionSplit = input.split("/");
      return "<sup>"+ fractionSplit[0]+"</sup>&frasl;<sub>"+fractionSplit[1]+"</sub>";
    }else{
      return input;
    }
  }

  function MultichoiceButtons(){
    let ychoices = shuffledAnswers[questionNum];
    console.log(shuffledAnswers);
    console.log(ychoices);

    return (
    <div>
       {ychoices.map(answer => {
        if(useranswers[questionNum] == "" || answer != useranswers[questionNum]){
          return (
            <MButton
            {...console.log(answer)}
            value={<div dangerouslySetInnerHTML={answer} />}
            style={{ flex: 1, margin: "20px" }}
            onClick={() => PressMulti(answer)}
          >
              <div style={{ height: "80%", width: "100%" }}>
              <Textfit mode="multi" max="99" style={{ textShadow: "2px 2px 4px #000000", position: "relative", top: "24%", height: "90%" }}>
                <span dangerouslySetInnerHTML={{ __html: ConvertAnswerText(answer) }}/>
                </Textfit>
              </div>
          </MButton>
         )}
        return (
          <MButtonSelected
          {...console.log("SELECTED")}
          value={<div dangerouslySetInnerHTML={answer} />}
          style={{ flex: 1, margin: "20px" }}
          onClick={() => PressMulti(answer)}
        >
            <div style={{ height: "80%", width: "100%" }}>
              <Textfit mode="multi" max="99" style={{ textShadow: "2px 2px 4px #000000", position: "relative", top: "24%", height: "90%" }}>
                <span dangerouslySetInnerHTML={{ __html: ConvertAnswerText(answer) }}/>
              </Textfit>
            </div>
        </MButtonSelected>
        )
      })}
    </div>
    )
  }

  function GameOver(){
    setGameOver(true);//go to endscreen
  }

  function ShowMarks(){
    //IF QUESTION NUMBER GREATER THAN NUMBER OF QUESTIONS DISPLAY BLANK BACKGROUND
    if (questionNum >= questions.length){
      return "";
    }else{
      return marks1;
    }
  }

  function CompareIfCorrect(youranswer, question){
    if (question.type != "MC"){
      //for decimals needs to convert
      if (question.answer.includes(".")){
        var correctAnswer = parseFloat(question.answer).toFixed(2);
        youranswer = parseFloat(youranswer);
        if (youranswer == null){
          return false;
        }
        if (youranswer.toFixed(2) == correctAnswer){
          return true;
        }else{
          return false;
        }
      }else{
        if (question.answer == youranswer){
          return true;
        }else{
          return false;
        }
      }
    }else{
      var correct = question.answer.split("|")[0];
      if (youranswer == correct){
        return true;
      }else{
        return false;
      }
    }
  }

  //I moved this to be called from the practicegameassessment script so it is done on timeout and ending game
  async function SubmitAssessment(){
     var correct = 0;      
    var questionsAnswered = [];
    for (let i = 0; i < questions.length; i++) {
        if (CompareIfCorrect(useranswers[i], questions[i])){
          let data = {
            question: questions[i].question,
            correct: true,
            answer: useranswers[i]
        };
        correct++;
        questionsAnswered.push(data);
        }else{
          let data = {
            question: questions[i].question,
            correct: false,
            answer: useranswers[i]
        };
        questionsAnswered.push(data);
        }
      console.log(JSON.stringify(questionsAnswered));
    }

    var topicstats = [];
    let temptih = {
      topic_key : "mathsassessmentsub",
      game_key : "basic_mathments",
      num_asked : questionsAnswered.length,
      num_correct : correct,
      average_ans_time : "0.0"
    }
    topicstats.push(temptih);

    axios({
        url: `${process.env.REACT_APP_API}/submissions`,
        method: "post",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
            "Authorization": `Bearer ${authState.access_token}`
        },
        data: {
            "homework_id": props.homework.id,
            "topicstats": topicstats,
            "custom": null,
            "platform": "Assessment|" + "WEB" + "|" + process.env.REACT_APP_VERSION_NO,
            "game_id": props.homework.galaxy_id,
            "questionsAnswered": JSON.stringify(questionsAnswered)
        }
      }).then((response) => {
        setGameOver(true);//go to endscreen
      })
  }

  function SubmitTimeout(){
    SubmitAssessment();
  }

  
  async function nextQuestion(value)
  {
    questionNum++;
    //will haver to do something for when questionum == to the question list count to display the final submission page
    newQuestion();
    //setClear(true);
  }

  function ResetClear(){
    setClear(false);
  }

  async function previousQuestion(value)
  {
    questionNum--;
    //will haver to do something for when questionum == to the question list count to display the final submission page
    newQuestion();
  }

  //this returns a table that ticks what questions are done
  function GetEndTable(){
    var html = "";
    html+= "<div>"
    //create a table where it equals amount of questions
    html+= '<table style="margin-top: 20%; width:100%; border-collapse: collapse;">'
    html+= '<tr>'

    let howManyPerRow = 12
    let amountSoFar = 0;

    for (let i = 0; i < useranswers.length; i++){
      var element = useranswers[i];

      if (element == ""){
        html+= '<td style="height: 100px; border: 1px solid #9999; font-size: 3em">Q'+(i+1)+' </td>'
      }else{
        html+= '<td style="height: 100px; background: #FFA500; border: 1px solid #9999; font-size: 3em">Q'+(i+1)+' </td>'
      }

      amountSoFar++;
      if (amountSoFar > howManyPerRow){
        amountSoFar = 0;
        html+= '</tr><tr>';
      }
    }
    
    html+= "</tr>";
    html+="</table>";
    html+= "</div>";

    return html;
  }

  //I don't know how to comment html/CSS
  return (
    <>
      <PracticeGame
        parent={props}
        gameOver={gameOver}
        SubmitMethod={() => SubmitTimeout()}
        correct={correctQuestions}
        incorrect={incorrectQuestions}
        score={score}
        defaultTimer={timer}
        questionNum={questionNum}
        questionNumMax ={questions.length}
        questionLimit={questionMax}
        onBack={() => props.onBack()}
        loading={loading}
        feedback={feedback}
        questionFontSize="0.7em"
        restart={() => {
          setCombo(0);
          setScore(0);
          setCorrectQuestions([]);
          setIncorrectQuestions([]);
        }}
      >
        <div id="scalinghere">
        <div style={{ backgroundImage: `url(${ShowMarks()}), url(${QuestionImage()})`, position: "relative", top: "-10%", height: "1400px", backgroundSize: "cover" }} >

            <Body>
              
              <div style={{ width: "80%" }}>
                {currQuestion != undefined ? (


                  <Container update={refresh}>

                    <div style={{ display: "flex", flexDirection: "row", alignSelf: "flex-end" }}>
                        <div style={{
                          position: "relative",
                          top: "15%",
                          right: "5%",
                          width: "100%",
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between"
                        }}>
                          {currQuestion.type == "NP" &&
                            <AsCalculator
                            onChange={setAnswer}
                            fakeprop={true}
                            resetclear = {ResetClear}
                            currentQuestion={currQuestion}
                            currentAnswer={useranswers[questionNum]}
                            //ref={this.calculator}
                            />
                          }
                          {currQuestion.type == "MC" &&
                            <MultiChoiceContainer>
                            {MultichoiceButtons()}
                            </MultiChoiceContainer>
                            }
                {currQuestion.type == "NPF" &&
                 <AsCalculatorFraction
                 onChange={setAnswer}
                 fakeprop={true}
                 resetclear = {ResetClear}
                 currentQuestion={currQuestion}
                 currentAnswer={useranswers[questionNum]}
                 //ref={this.calculator}
                 />

                }
                 {currQuestion.type == "NPFM" &&
                 <AsCalculatorFractionMixed
                 onChange={setAnswer}
                 fakeprop={true}
                 resetclear = {ResetClear}
                 currentQuestion={currQuestion}
                 currentAnswer={useranswers[questionNum]}
                 //ref={this.calculator}
                 />

                }
                          
                        </div>
                    </div>
                    
                    <NavigationContainer>
                    {NavigationButtons()}
                    </NavigationContainer>

                  </Container>

                ) : <div>
                  <div dangerouslySetInnerHTML={{ __html: GetEndTable() }}>
                </div><NavigationContainer>{NavigationButtons()}</NavigationContainer></div> }
              </div>
            </Body>
        </div>
        </div>
      </PracticeGame>
    </>
  );
}

const NavigationContainer = styled.div`
  position: fixed;
  top: 70%;
  right: 50%;
`

const Body = styled.div`
        width: 100%;
        height: 100%;
  background-image: url("");
        background-size: cover;
        background-position: 0px -1px;
        display: flex;
        justify-content: center;
        padding-top: 100px;
      `;

const Result = styled.div`
        width: 100%;
        height: 100%;
        font-size: 5em;
        text-align: center;
        border: solid 2px #683d8c;
      `;

const Combo = styled.div`
        background: #4391bb;
        width: 120px;
        height: 120px;
        border-radius: 75px;
        border: solid #204b7b 4px;
        display: flex;
        flex-direction: column;
        text-align: center;
        color: #fff;
        justify-content: center;
        font-weight: 600;
        margin-left: 50px;
      `;

const Container = styled.div`
      width:100%%;
      height:95%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding-bottom:100px;
      `;

const Question = styled.div`
      background: #FFF;
      user-select: none;
      width: 90%;
      height: 120px;
      line-height: 90px;
      font-size: 4em;
      margin: 15px 25px;
      text-align: center;
      font-weight: 600;
      border: none;
      border-radius: 10px;
    `;

const Button = styled.div`
    text-align: center;
    width: 20%;
    height: 150px;
    margin: 5px;
    color: #fff;
    user-select: none;
    background: rgb(234, 146, 19);
    background: linear-gradient(
      0deg,
      rgba(234, 146, 19, 1) 0%,
      rgba(255, 186, 32, 1) 100%
    );
    border: 2px solid #e88f12;
    box-sizing: border-box;
    border-radius: 0.25em;
    cursor: pointer;
    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
      margin-bottom: 0;
    }
  `;

  const NavigationButton = styled.div`
    text-align: center;
    width: 118px;
    height: 144px;
    margin: 5px;
    position: absolute;
    right: -1000px;
    top: 150px
    background-image: url(${next});
    color: #000;
    user-select: none;
    box-sizing: border-box;
    border-radius: 0.25em;
    cursor: pointer;
    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
      margin-bottom: 0;
    }
  `;

  const NavigationButtonBack = styled.div`
    text-align: center;
    width: 118px;
    height: 144px;
    margin: 5px;
    position: absolute;
    top: 150px;
    right: 1000px
    background-image: url(${back});
    color: #000;
    box-sizing: border-box;
    border-radius: 0.25em;
    cursor: pointer;
    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
      margin-bottom: 0;
    }
  `;

  const NavigationText = styled.div`
  margin: 0;
  position: absolute;
  top: 50%;
  left: 40%;
  transform: translate(-50%, -50%);
  font-size: 25px;
  user-select: none; /* supported by Chrome and Opera */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
}
  `;

  const NavigationTextBack = styled.div`
  margin: 0;
  position: absolute;
  top: 50%;
  left: 60%;
  transform: translate(-50%, -50%);
  font-size: 25px;
  user-select: none; /* supported by Chrome and Opera */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  `;

const ButtonImage = styled.img`
max-width: 80%;
max-height: 80%;
padding-top: 15px;
`

const MultiChoiceContainer = styled.div`
  position: relative;
  right: 20%;
`

const MButton = styled.div`
    text-align: center;
    width: 350px;
    height: 150px;
    margin: 5px;
    color: #fff;

    background: linear-gradient(
      0deg,
      rgba(200, 200, 200, 1) 0%,
      rgba(225, 225, 225, 1) 100%
    );
    border: 2px solid #fff;
    box-sizing: border-box;
    border-radius: 0.25em;
    cursor: pointer;
    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
      margin-bottom: 0;
    }
    user-select: none; /* supported by Chrome and Opera */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
  `;

  const MButtonSelected = styled.div`
  text-align: center;
  width: 350px;
  height: 150px;
  margin: 5px;
  color: #fff;
  background: linear-gradient(
    0deg,
    rgba(200, 200, 120, 1) 0%,
    rgba(225, 225, 100, 1) 100%
  );
  border: 2px solid #fff;
  box-sizing: border-box;
  border-radius: 0.25em;
  cursor: pointer;
  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    margin-bottom: 0;
  }
  user-select: none; /* supported by Chrome and Opera */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
`;